<section class="start-page-overlay" [ngStyle]="overlayStyles">
  @if (showAnimation) {
    <app-harmonized-shapes></app-harmonized-shapes>
  }
  <app-welcome-overlay [user]="user" [message]="" [viewportSize]="viewportSize"></app-welcome-overlay>
</section>
